import React from 'react';

const PhoneIcon = ({ color, opacity, size = 16 }) => {
  const iconColor = color || "#1D1917";
  const iconOpacity = opacity !== undefined ? opacity : 1;
  
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" opacity={iconOpacity} fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.91675 8.74998H12.0834" stroke={iconColor} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M10.4167 10.4166L12.0834 8.74998L10.4167 7.08331" stroke={iconColor} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
<path fillRule="evenodd" clipRule="evenodd" d="M10.4225 15H15C16.3807 15 17.5 13.8807 17.5 12.5V5C17.5 3.61929 16.3807 2.5 15 2.5H5C3.61929 2.5 2.5 3.61929 2.5 5V12.5C2.5 13.8807 3.61929 15 5 15H6.6725V17.0358C6.6725 17.2139 6.77461 17.3763 6.93517 17.4534C7.09572 17.5306 7.2863 17.5089 7.42541 17.3976L10.4225 15Z" stroke={iconColor} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
</svg>

  );
};

PhoneIcon.defaultProps = {
  size: 16,
  opacity: 1,
  color: "#1D1917",
};

export default PhoneIcon;

